import React from 'react';
import { translate } from '../../../../../common/intl';
import { CustomTreeListColumnProps } from '../../../../components/common/treelist/types';
import { MODE_FIELD } from '../constants';
import { ActionsCell } from '../components/Actions';
import PlannedIdCellTemplate from '../components/PlannedIdCellTemplate';
import QuantityCell from '../components/QuantityCell';
import UnitsCellTemplate from '../components/UnitsCellTemplate';
import { SchemaOptions } from '../types';

export const buildLHRTSchema = ({
  onRowClick,
  actionsClass,
  popperHolder,
  onConfirm,
  onDiscard,
  isLHRT,
}: SchemaOptions): CustomTreeListColumnProps[] => [
  {
    id: 'title',
    field: 'title',
    title: translate('form.builder.procedure.material.title'),
    mainOrderIndex: 1,
    cell: (props) => <PlannedIdCellTemplate {...props} onClick={onRowClick} isLHRT={isLHRT} />,
  },
  {
    id: 'quantity',
    field: 'quantity',
    title: translate('form.builder.procedure.material.table.quantity.title'),
    cell: (props) => <QuantityCell {...props} onClick={onRowClick} isLHRT />,
    mainOrderIndex: 4,
    width: 150,
  },
  {
    id: 'unit',
    field: 'unit',
    title: translate('form.builder.procedure.material.table.unit.title'),
    headerClassName: 'pre-actions-header',
    cell: (props) => <UnitsCellTemplate {...props} onClick={onRowClick} isLHRT />,
    mainOrderIndex: 5,
    width: 150,
  },
  {
    id: 'actions',
    locked: false,
    cell: (props) => (
      <td className={actionsClass}>
        {Boolean(props.dataItem[MODE_FIELD]) && (
          <ActionsCell
            {...props}
            onConfirm={onConfirm}
            onDiscard={onDiscard}
            rootClassName={popperHolder}
          />
        )}
      </td>
    ),
    width: 0,
  },
];
